import $ from 'jquery';


export default () => {
    //mega-menu-toggle
    if ($(window).width() >= 992) {
        $('.mega-menu-toggle, .mega-menu-desktop').on('mouseenter', function (e) {
            $('header').addClass('mega-menu-active');
            $('.mega-menu-toggle').addClass('active');
            $(this).addClass('active');
        }).on('mouseleave', function (e) {
            $('header').removeClass('mega-menu-active');
            if($('.mega-menu-toggle').attr('class').indexOf('keep-active') == -1) {
                $('.mega-menu-toggle').removeClass('active');
            }
            $(this).removeClass('active');
        });
    } else {
        /*
        mega menu mobile messo in absolute al top sopra l'overlay...
        al click viene posizionato sotto il btn che triggera l'apertura e gli viene data altezza
        */
        var megamenuHeight = $('.mega-menu-mobile').height() + 'px';
        var $megamenu = $('.mega-menu-mobile');
        $('.mega-menu-mobile').css({ 'height': 0 });
        $('.overlay .mega-menu-toggle').find('a');
        $('.overlay .mega-menu-toggle').addClass('p-0').append($megamenu);
        $('.overlay .mega-menu-toggle a').on('click', function (e) {
            //console.log('mega-menu-mobile');
            var $that = $(this);
            var offset = $that.parent().offset().top;
            var height = $that.parent().height() + offset - ($that.parent().height() / 2);
            $that.css('transition', 'all 0.3s ease-out');
            if ($('.mega-menu-mobile').attr('class').indexOf('active') == -1) {
                //$that.css('padding-bottom', 'calc(100vh - ' + height + 'px )');
                $('.mega-menu-mobile').css({ 'height': megamenuHeight });
                $('.mega-menu-mobile').addClass('active');
            } else {
                $('.mega-menu-mobile').css('height', 0);
                //$that.css('padding-bottom', '0px');
                $('.mega-menu-mobile').removeClass('active');
            }
        });
    }
    var activeMegaMenuItem = $('.mega-menu-mobile, .mega-menu-desktop').find('.active');
    //console.log(activeMegaMenuItem.length);
    if(activeMegaMenuItem.length > 0) {
        $('.mega-menu-toggle').addClass('current_page_item active keep-active');
    }
};





// WEBPACK FOOTER //
// ./scripts/libs/mega-menu.js